import { Rank } from '../../sim/defs';
import { Fam } from '../../sim/pools/BulletPool';
import { defineEnemy, Motion, Pattern } from '../schema';

/** E04 — FAUCHEUR. L'unité de mesure de la difficulté.
 *
 *  Se poste à Y = +300 et tire un éventail visé de 3 projectiles toutes les
 *  1,3 s. C'est la référence de tout l'équilibrage du jeu : **on règle un
 *  niveau en changeant leur NOMBRE, jamais leurs statistiques.**
 *
 *  Cette discipline compte plus qu'elle n'en a l'air. Toucher aux stats d'un
 *  ennemi de référence invalide l'intuition qu'on a construite sur tous les
 *  autres ; en changer la quantité laisse cette intuition intacte. */
export default defineEnemy({
  id: 'faucheur',
  rank: Rank.Heavy,
  hp: 180,
  visualRadius: 40,
  score: 300,
  telegraph: 1.1,
  drops: 3,
  motion: { kind: Motion.Hover, speed: 260, amplitude: 90, frequency: 0.8, holdY: 300 },
  emitter: {
    pattern: Pattern.Aimed,
    every: 1.3,
    count: 3,
    spreadDeg: 22,
    speed: 450,
    firstDelay: 1.3,
    family: Fam.EnemyPink,
  },
});

